import { defineComponent as _defineComponent } from 'vue'
import { $session } from "framework"
import { nextTick, onBeforeUpdate, computed, reactive, ref, watch } from "vue"
import { useSiteStore } from "@/store/site"
import { useAuthStore } from "@/store/auth"
import router from "@/router"

interface UserInfo {
  NAME: string;
  USER_ID: string;
  USER_NO: string;
  USER_ROLES: {
    dotSaasVision: string;
    dotSaasClass: string;
    dotSaasSupport: string;
  };
}

interface State {
  userInfo: UserInfo;
}

interface Store {
  param: {
    a: string;
    r: string;
    u: string;
  } | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginBtn',
  setup(__props, { expose: __expose }) {
  __expose();

const siteStore: Store = useSiteStore()
const authStore = useAuthStore()

const isLogin = computed(() => authStore.isAuthenticated)

const state = reactive<State>({
  userInfo: {
    NAME: "",
    USER_ID: "",
    USER_NO: "",
    USER_ROLES: {
      dotSaasVision: "",
      dotSaasClass: "",
      dotSaasSupport: "",
    },
  },
});
const initUserInfo = () => {
  const userName = $session.getUserInfo()?.NAME?.slice(0, 1) || "U";
  const userId = $session.getUserInfo()?.USER_ID;
  const userNo = $session.getUserNo();
  const userRole = $session.getUserRoles("dot-saas-support");

  state.userInfo.NAME = userName;
  state.userInfo.USER_NO = userNo;
  state.userInfo.USER_ID = userId;
  state.userInfo.USER_ROLES.dotSaasSupport = userRole;
};

if (isLogin.value) {
  initUserInfo();
}

watch(isLogin, (val) => {
  if (val) {
    initUserInfo();
  } else {
    state.userInfo = {
      NAME: "",
      USER_ID: "",
      USER_NO: "",
      USER_ROLES: {
        dotSaasVision: "",
        dotSaasClass: "",
        dotSaasSupport: "",
      },
    };
  }
});

const menu = ref(false)
const btnList = [
  {
    key: "profile",
    label: "프로필"
  },
  {
    key: "logout",
    label: "로그아웃"
  }
]
const btnRefs = ref<HTMLElement[]>([])

watch(menu, async (isOpen) => {
  if (!isOpen) return

  await nextTick()
  requestAnimationFrame(() => {
    const el = btnRefs.value[0]
    if (el instanceof HTMLElement) {
      el.focus()
    }
  })
})

const login = () => {
  router.push("/login")
}

const profile = () => {
  const sso = $session.getSsoDomain();
  const s = $session.getSiteNo();
  const c = $session.getCompNo();
  const a = siteStore.param?.a;
  const cb = window.location.origin;

  const url = `${sso}/basic?s=${s}&c=${c}&a=${a}&cb=${cb}/login-callback`;

  window.open(url)
}

const logOut = async () => {
  await $session.signOut();

  authStore.setAuthenticated(false);

  state.userInfo = {
    NAME: "",
    USER_ID: "",
    USER_NO: "",
    USER_ROLES: {
      dotSaasVision: "",
      dotSaasClass: "",
      dotSaasSupport: "",
    },
  };
};

const onBtnItemKeydown = (
    event: KeyboardEvent,
    index: number,
    code: string
) => {
  const key = event.key

  console.log("on btn item keydown evet", index, code)

  if (key === "ArrowDown" || key === "ArrowUp") {
    event.preventDefault()

    const lastIndex = btnList.length - 1
    let nextIndex = index

    if (key === "ArrowDown") {
      nextIndex = index === lastIndex ? 0 : index + 1
    }
    else if (key === "ArrowUp") {
      nextIndex = index === 0 ? lastIndex : index - 1
    }
    requestAnimationFrame(() => {
      const el = btnRefs.value[nextIndex]
      if (el instanceof HTMLElement) {
        el.focus()
      }
    })
    return
  }

  if (key === "Enter" || key === " " || key === "Spacebar") {
    event.preventDefault()
    event.stopPropagation()
    onClickHandler(code)
  }
}

const onClickHandler = (key: string) => {
  switch (key) {
    case "profile":
      profile()
      break
    case "logout":
      logOut()
      break
  }
}

onBeforeUpdate(() => {
  btnRefs.value = []
})

const __returned__ = { siteStore, authStore, isLogin, state, initUserInfo, menu, btnList, btnRefs, login, profile, logOut, onBtnItemKeydown, onClickHandler, get $session() { return $session } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})